var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment');
var loaders = require('../layout/components/loaders');
var button = require('../components/button');
var confirmationModal = require('../data/components/calibrationEnableModal');
var calibrateModal = require('../data/components/calibrateModal');
var downloadCalibrationReport = require('../data/components/downloadCalibrationReport');
var pathHeader = require('../layout/components/pathHeader');
var pageRequestState = require('../layout/components/pageRequestState');

var dateFormat = 'dddd MMMM D YYYY';

function getActionTimestamp(performedOnEdge) {
  var timestamp = performedOnEdge && performedOnEdge.out ? Number(performedOnEdge.out.timestamp) : NaN;
  return Number.isFinite(timestamp) ? timestamp : null;
}

function getLatestPerformedOn(performedOnEdges) {
  if (!Array.isArray(performedOnEdges) || performedOnEdges.length === 0) {
    return null;
  }

  return performedOnEdges.reduce(function (latest, edge) {
    if (!latest) {
      return edge;
    }

    var latestTimestamp = getActionTimestamp(latest);
    var edgeTimestamp = getActionTimestamp(edge);

    if (latestTimestamp === null && edgeTimestamp === null) {
      return edge;
    }

    if (latestTimestamp === null) {
      return edge;
    }

    if (edgeTimestamp === null) {
      return latest;
    }

    return edgeTimestamp >= latestTimestamp ? edge : latest;
  }, null);
}

function getReferenceInstrumentName(actionRecord) {
  var usedFor = actionRecord && Array.isArray(actionRecord.in_usedFor) ? actionRecord.in_usedFor : [];
  return usedFor[0] && usedFor[0].out && usedFor[0].out.name ? usedFor[0].out.name : '';
}

var equipmentCalibration = {};

equipmentCalibration.oninit = function (vnode) {
  pageRequestState.initialize(vnode.state);
  vnode.state.init = function () {
    vnode.state.temperatureColumn = null;
    vnode.state.lastAsset = null;
    vnode.state.lastAction = null;
    vnode.state.lastActionOffset = undefined;
    vnode.state.lastCalibrationUser = null;
    vnode.state.equipmentRecord = null;

    return pageRequestState.run(vnode.state, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/equipment/' + m.route.param('id'),
        method: 'GET'
      })
      .then(function (result) {
        if (!result || !Array.isArray(result.path)) {
          throw new Error('Equipment response is missing its location path.');
        }

        vnode.state.equipmentRecord = result;
        vnode.state.fakePath = vnode.state.equipmentRecord.path.slice().reverse();
        vnode.state.fakeNodePath = { '@rid': 1, 'name': 'Calibrations' };
        vnode.state.fakePath.push(vnode.state.fakeNodePath);
        if (vnode.state.equipmentRecord.out_Contains && Array.isArray(vnode.state.equipmentRecord.out_Contains)) {
          let defaultContainsEdge = vnode.state.equipmentRecord.out_Contains.find(containsRecord => containsRecord.in && containsRecord.in.name == 'Default');
          if (defaultContainsEdge && defaultContainsEdge.in && defaultContainsEdge.in.out_Column && Array.isArray(defaultContainsEdge.in.out_Column)) {
            vnode.state.temperatureColumn = defaultContainsEdge.in.out_Column.find(columnRecord => columnRecord.name == 'Temperature');
            if (vnode.state.temperatureColumn && vnode.state.temperatureColumn.in && vnode.state.temperatureColumn.in.in_pointOf && Array.isArray(vnode.state.temperatureColumn.in.in_pointOf)) {
              vnode.state.lastAsset = vnode.state.temperatureColumn.in.in_pointOf[vnode.state.temperatureColumn.in.in_pointOf.length - 1].out;
              if (vnode.state.lastAsset && vnode.state.lastAsset.in_performedOn && Array.isArray(vnode.state.lastAsset.in_performedOn)) {
                var latestPerformedOn = getLatestPerformedOn(vnode.state.lastAsset.in_performedOn);
                vnode.state.lastAction = latestPerformedOn && latestPerformedOn.out;
                vnode.state.lastActionOffset = vnode.state.lastAction ? vnode.state.lastAction.offset : undefined;
                if (vnode.state.lastAction && vnode.state.lastAction.performedBy) {
                  return loaders.requestWithLoader({
                    url: "/api/v1/user/" + vnode.state.lastAction.performedBy.slice(1),
                    method: "GET",
                    loader: 'background'
                  })
                    .then(function (userRecord) {
                      vnode.state.lastCalibrationUser = userRecord;
                    })
                    .catch(function (error) {
                      // The calibration information remains useful even when
                      // the optional user lookup is temporarily unavailable.
                      console.error('Unable to load calibration user:', error);
                      return null;
                    });
                }
              }
            }
          }
        }
      });
    }, { errorMessage: 'Unable to load calibration data:' })
    .then(function (result) {
      m.redraw();
      return result;
    });
  };
  return vnode.state.init();
};

equipmentCalibration.view = function (vnode) {
  var stateView = pageRequestState.view(vnode.state);
  if (stateView) return stateView;
  if (!vnode.state.equipmentRecord) {
    return m('div');
  }
  return m('div.mh3.mv3', [
    m(pathHeader, {
      ancestors: vnode.state.fakePath,
      record: vnode.state.fakeNodePath,
    }),
    (() => {
      if (!vnode.state.temperatureColumn) {
        return m('div', 'The equipment record is missing a temperature point on the default dataset.');
      }
      if (!vnode.state.temperatureColumn.in.in_pointOf || vnode.state.temperatureColumn.in.in_pointOf.length == 0) {
        return m('div', [
          m('fr', [
            m(button, {
              label: 'Begin calibration tracking',
              func: confirmationModal.editDialogue.bind(confirmationModal, { point: vnode.state.temperatureColumn.in['@rid'] }, { submitCallback: vnode.state.init }),
              class: 'w5 fr mt2'
            })
          ])
        ]);
      } else {
        var calibrationDate = vnode.state.lastAsset ? new Date(vnode.state.lastAsset.lastAction) : undefined;
        var nextCalibrationDate = vnode.state.lastAsset ? new Date(calibrationDate) : undefined;
        nextCalibrationDate ? nextCalibrationDate.setFullYear(calibrationDate.getFullYear() + 1) : undefined;
        var referenceInstrument = getReferenceInstrumentName(vnode.state.lastAction);

        return m('div', [
          m('div.flex.justify-between.items-center.bb.bw1.pr3', [
            m("p", "Next Calibration: "),
            (function () {
              if (vnode.state.lastAsset && vnode.state.lastAsset.lastAction) {
                return m("p", moment(nextCalibrationDate).format(dateFormat))
              } else {
                return m("p", 'Pending')
              }
            })()
          ]),
          m('div.flex.justify-between.items-center.bb.bw1.pr3', [
            m("p", "Last Calibrated: "),
            (function () {
              if (vnode.state.lastAsset && vnode.state.lastAsset.lastAction) {
                return m("p", moment(vnode.state.lastAsset.lastAction).format(dateFormat))
              } else {
                return m("p", 'Never')
              }
            })()
          ]),
          m('div.flex.justify-between.items-center.bb.bw1.pr3', [
            m("p", "Calibrated By: "),
            m("p", vnode.state.lastCalibrationUser ? vnode.state.lastCalibrationUser.firstName + ' ' + vnode.state.lastCalibrationUser.lastName : 'Nobody'),
          ]),
          m('div.flex.justify-between.items-center.bb.bw1.pr3', [
            m("p", "Reference Instrument: "),
            m("p", referenceInstrument),
          ]),
          m('div.flex.justify-between.items-center.bw1.pr3', [
            m('div.flex.justify-end.w-30', [
              m(button, {
                label: 'Edit',
                func: confirmationModal.editDialogue.bind(confirmationModal, vnode.state.lastAsset, { submitCallback: vnode.state.init }),
                class: 'fr mv2 w-100 blue'
              })
            ]),
            m('div.flex.justify-end.w-30', [
              m(button, {
                label: 'Start Calibration',
                func: calibrateModal.editDialogue.bind(calibrateModal, vnode.state.temperatureColumn.in, { submitCallback: vnode.state.init, lastOffset: vnode.state.lastActionOffset }),
                class: 'fr mv2 w-100 blue'
              })
            ]),
            m('div.flex.justify-end.w-30', [
              vnode.state.lastAsset && vnode.state.lastAsset.in_performedOn && vnode.state.lastAsset.in_performedOn.length > 0 ?
                m(button, {
                  label: 'Download',
                  func: downloadCalibrationReport.bind(null, vnode.state.lastAsset['@rid']),
                  class: 'fr mv2 w-100 green'
                })
                : ''
            ])
          ]),
        ])
      }
    })(),

  ])
};

module.exports = equipmentCalibration;
